import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/**
 * A base service using RTK Query's fetchBaseQuery. Used for fetching local or static resources.
 */
export const staticContentService = createApi({
  reducerPath: 'staticContentService',
  baseQuery: fetchBaseQuery(),
  endpoints: () => ({}),
});
